import { render, staticRenderFns } from "./TiarcoChemicalM.vue?vue&type=template&id=54601e71"
import script from "./TiarcoChemicalM.vue?vue&type=script&lang=ts"
export * from "./TiarcoChemicalM.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports